import { useLocation } from 'react-router-dom';
import { useRef, useState } from 'react';
import { Button, Modal, Toast } from '@common-web';
import { setQuickLinks } from '@reducers/quick-links-slice/index.js';
import { useDispatch } from 'react-redux';
import { createQuickLinkApi } from '@apis/seller-center/quick-links.js';
import { getErrorString } from '@utils/utils.js';
import { findQuickLink } from '../../helper';
import SaveModalBody from '../save-modal-body';
import { strings } from '@constants/strings';

const SaveQuickLink = ({ linkType = '', quickLinks = [] }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [saveModal, setSaveModal] = useState(false);
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const handleSave = async (values) => {
    if (!values.name) return;

    const payload = {
      name: values.name,
      link: `${location.pathname}${location.search}`,
      link_type: linkType,
    };

    try {
      setLoading(true);
      const response = await createQuickLinkApi(payload);
      dispatch(setQuickLinks([...quickLinks, response.quick_link]));
      setSaveModal(false);
      setLoading(false);
    } catch (err) {
      Toast.error(getErrorString(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {location.search && !findQuickLink({ location, quickLinks }) && (
        <Button
          text={'Save Search'}
          onClick={() => setSaveModal(true)}
          size="small"
          type="primary-light"
          icon="MdBookmark"
        />
      )}

      <Modal
        title={'Save Search'}
        open={saveModal}
        okButtonProps={{ loading }}
        okText={strings.save_changes}
        ModalBody={<SaveModalBody handleSave={handleSave} ref={formRef} />}
        handleCancel={() => {
          setSaveModal(false);
        }}
        handleOk={() => {
          formRef?.current?.submitForm();
        }}
        width={525}
        destroyOnClose={true}
        showActions={true}
      />
    </>
  );
};

export default SaveQuickLink;
